import React from 'react';
import { useAuth } from '../contexts/AuthContext';

interface RoleBasedComponentProps {
  children: React.ReactNode;
  requiredPermissions?: string[];
  requiredRoles?: string[];
  fallback?: React.ReactNode;
  hideIfNoAccess?: boolean;
  requireAll?: boolean; // true: all permissions required, false: any permission required
}

const RoleBasedComponent: React.FC<RoleBasedComponentProps> = ({
  children,
  requiredPermissions = [],
  requiredRoles = [],
  fallback = null,
  hideIfNoAccess = false,
  requireAll = true
}) => {
  const { hasPermission, hasRole } = useAuth();

  // Check if user has required roles
  const hasRequiredRole = requiredRoles.length === 0 || requiredRoles.some(role => hasRole(role));

  // Check if user has required permissions
  let hasRequiredPermissions = true;
  if (requiredPermissions.length > 0) {
    if (requireAll) {
      // All permissions required
      hasRequiredPermissions = requiredPermissions.every(permission => hasPermission(permission));
    } else {
      // Any permission required
      hasRequiredPermissions = requiredPermissions.some(permission => hasPermission(permission));
    }
  }

  const hasAccess = hasRequiredRole && hasRequiredPermissions;

  if (!hasAccess) {
    if (hideIfNoAccess) {
      return null;
    }
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default RoleBasedComponent;